import React from "react";

// components
import SchemaDecisionMaker from "./SchemaDecisionMaker";
import NewSchemaOptions from "./NewSchemaOptions";
import SchemaContent from "./SchemaContent";
import ComingSoonFeature from "../../components/console/ComingSoonFeature";
import AddClassForm from "./AddClassForm";
import WeaviateErrorPage from "../../components/console/WeaviateErrorPage";
import Spinner from "../../components/console/Spinner";

// React Router Dom
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
const SchemaRoutes = ({ schema }) => {
  return (
    <Router>
      <Switch>
        <Route
          path="/console/Schema/weaviate-not-connected"
          render={() => <WeaviateErrorPage />}
        />

        <Route
          path="/console/Schema/new-schema/add-class/coming-soon-feature"
          render={() => <ComingSoonFeature module={schema} />}
        />
        <Route
          path="/console/Schema/new-schema/file-upload/coming-soon-feature"
          render={() => <ComingSoonFeature />}
        />

        <Route path="/console/Schema/spinner" render={() => <Spinner />} />

        <Route
          path="/console/Schema/new-schema/new-class"
          render={() => <AddClassForm schema={schema} />}
        />

        <Route
          path="/console/Schema/new-schema"
          render={() => <NewSchemaOptions />}
        />
        <Route
          path="/console/Schema/view-schema"
          render={() => <SchemaContent schema={schema} />}
        />
        <Route
          path="/console/Schema"
          render={() => <SchemaDecisionMaker schema={schema} />}
        />
      </Switch>
    </Router>
  );
};

export default SchemaRoutes;
